<template>
  <div class="link-iframe-wrapper">
    <iframe
      class="link-iframe"
      marginWidth="0"
      marginHeight="0"
      scrolling="auto"
      frameBorder="0"
      width="100%"
      :src="src || linkSrc"
    ></iframe>
  </div>
</template>

<script>
export default {
  name: "linkIframe",
  props: {
    linkSrc: {
      default: null
    }
  },
  data() {
    return {
      src: ""
    }
  },
  methods: {
    initIframeSrc() {
      this.src = this.$route.query.linkSrc
    }
  },
  created() {
    // this.initIframeSrc()
  }
}
</script>

<style lang="scss" scoped>
.link-iframe-wrapper {
  height: 100vh;
  width: 100%;
  background: #ffffff;
  position: relative;
  overflow: hidden;

  .link-iframe {
    width: calc(100% + 0.3rem);
    border: none;
    height: 100vh;

    position: absolute;
    right: -0.3rem;
    top: 0;
    bottom: 0;

    overflow-x: hidden;
    overflow-y: scroll;
  }
}
</style>
